import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Card,
  CardBody,
  Col,
  Collapse,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  UncontrolledAccordion,
} from "reactstrap";
import { GetCookieToken } from "../Cookie/GetCookie";
import axios from "axios";
import { useInsertConText } from "../Context/InsertContext";
import LoadingData from "../TESTPage/LoadingData";
import FadeIn from "react-fade-in/lib/FadeIn";

const API_URL = process.env.REACT_APP_API_CORS;

function escapeRegExp(string) {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
}

function ModalConID(props) {
  const { task, user_id, taskFilter, defaultValues = null } = props;
  const { insert, setInsert } = useInsertConText();
  const token = GetCookieToken("userToken");
  const [modal, setModal] = useState(false);
  const [data, setData] = useState([]);
  const [dataSort, setDataSort] = useState([]);
  const [activeItem, setActiveItem] = useState(defaultValues);
  const [isCollapseOpen, setCollapseIsOpen] = useState(false);
  const [buttonIcons, setButtonIcons] = useState({});
  const [isOpenCollapseNested, setIsOpenCollapseNested] = useState({});
  const [buttonStates, setButtonStates] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [allarray, setAllarray] = useState([]);
  const [valueSearch, setValueSearch] = useState([]);
  const [insert_id, setInsert_id] = useState();
  const [insert_name, setInsert_name] = useState();
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    const url = `${API_URL}/api/orgInner/level`;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then(response => {
        setData(response.data.result);

        const combinedArray = [
          ...response.data.result.child?.map(org => [
            org.org_name,
            org.org_id,
            org.active,
          ]),
          ...response.data.result.child?.flatMap(org =>
            org.child?.map(i => [i.org_name, i.org_id, i.active])
          ),
        ];
        setAllarray(combinedArray);
      })
      .catch(error => console.error("Error:", error));
  };

  const handleListItemClick = (id, e, value) => {
    setActiveItem(id === activeItem ? null : id);
    setInsert_id(id);
    setInsert_name(e);
  };

  const toggle = () => {
    setLoading(true);
    setModal(!modal);
    fetchData();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const toggleCollapse = () => setCollapseIsOpen(!isCollapseOpen);

  const toggleCollapseNested = id => {
    setIsOpenCollapseNested(prevState => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };
  const setButton = id => {
    setButtonStates(prevState => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  useEffect(() => {
    const escapedTerm = escapeRegExp(searchTerm);
    const regex = new RegExp(escapedTerm, "i");
    setValueSearch(allarray.filter(item => regex.test(item[0])));
  }, [searchTerm]);

  const handleFinalClick = () => {
    setInsert({ insert_id, insert_name, task });
  };

  const handleClearClick = () => {
    setActiveItem(null);
  };

  return (
    <Fragment>
      <Button color="secondary" onClick={toggle}>
        <i className="fa-solid fa-list"></i>
      </Button>
      <Modal isOpen={modal} toggle={toggle} centered size="md">
        <ModalHeader>เลือกหน่วยงาน</ModalHeader>
        <ModalBody style={{ maxHeight: "550px", overflowY: "scroll" }}>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "500px",
              }}
            >
              <LoadingData />
            </div>
          ) : (
            <FadeIn>
              <FormGroup>
                <Col>
                  <Input
                    className="w-100"
                    placeholder="ค้นหา"
                    type="search"
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                  />
                </Col>
              </FormGroup>

              {searchTerm === "" ? (
                <ListGroup>
                  <Fragment>
                    <ListGroupItem
                      className="py-0"
                      action
                      active={data.org_id === activeItem}
                    >
                      <Row className="py-2" >
                        <Col xs={1} lg={1}>
                          <span
                            className="pe-2"
                            key={data.org_id}
                            style={{
                              cursor: "pointer",
                              transition: "background-color 0.3s",
                            }}
                            onClick={() => {
                              toggleCollapse();
                              setButton(data.org_id);
                              setButtonIcons(prevState => ({
                                ...prevState,
                                [data.org_id]:
                                  prevState[data.org_id] === "fa-solid fa-minus"
                                    ? "fa-solid fa-plus"
                                    : "fa-solid fa-minus",
                              }));
                            }}
                          >
                            {buttonIcons[data.org_id] ? (
                              <i className={buttonIcons[data.org_id]}></i>
                            ) : (
                              <i className="fa-solid fa-plus"></i>
                            )}
                          </span>
                        </Col>
                        <Col xs={6} lg={11}>
                          <div
                            onClick={() =>
                              handleListItemClick(data.org_id, data.org_name)
                            }
                            style={{
                              cursor: "pointer",
                              transition: "background-color 0.3s",
                            }}
                          >
                            {data.org_name ?? "กำลังโหลด..."}
                          </div>
                        </Col>
                      </Row>
                    </ListGroupItem>
                    <Collapse isOpen={isCollapseOpen}>
                      {data.child?.sort((a, b) => {
                          const nameA = a.org_name.toLowerCase();
                          const nameB = b.org_name.toLowerCase();
                          if (nameA < nameB) return -1;
                          if (nameA > nameB) return 1;
                          return 0;
                        }).map((org, index) =>
                        org.child.length !== 0 && org.active !== 0 && org.active !== undefined && org.org_id !== 57 && org.org_id !== 58 && org.org_id !== 72 && org.org_id !== 103 && org.org_id !== 117 && org.org_id !== 120 && org.org_id !== 173 && org.org_id !== 194 ? (
                          ""
                        ) : org.active !== 0 &&
                          org.active !== undefined &&
                          org.org_id !== 57 &&
                          org.org_id !== 58 &&
                          org.org_id !== 72 &&
                          org.org_id !== 103 &&
                          org.org_id !== 117 &&
                          org.org_id !== 120 &&
                          org.org_id !== 173 &&
                          org.org_id !== 194 ? (
                          <ListGroupItem
                            className="py-0"
                            action
                            active={org.org_id === activeItem}
                          >
                            <div
                              key={org.org_id}
                              className="my-2"
                              onClick={() =>
                                handleListItemClick(org.org_id, org.org_name)
                              }
                              style={{
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                                marginLeft: "3.2rem",
                              }}
                            >
                              {org.org_name}
                            </div>
                          </ListGroupItem>
                        ) : (org.active !== undefined && org.active !== 0 && taskFilter === "NEED_ADMINISTER" ?
                            <ListGroupItem className="py-0" action active={org.org_id === activeItem}>
                              <div
                                key={org.org_id}
                                className="my-2"
                                onClick={() =>
                                  handleListItemClick(org.org_id, org.org_name)
                                }
                                style={{
                                  cursor: "pointer",
                                  transition: "background-color 0.3s",
                                  marginLeft: "3.2rem",
                                }}
                              >
                                {org.org_name}
                              </div>
                            </ListGroupItem> : ""
                        )
                      )}
                    </Collapse>
                    <Collapse isOpen={isCollapseOpen}>
                      {data.child?.sort((a, b) => {
                          const nameA = a.org_name.toLowerCase();
                          const nameB = b.org_name.toLowerCase();
                          if (nameA < nameB) return -1;
                          if (nameA > nameB) return 1;
                          return 0;
                        }).map((org, index) =>
                        org.child.length !== 0 &&
                          org.active !== 0 &&
                          org.active !== undefined &&
                          org.org_id !== 57 &&
                          org.org_id !== 58 &&
                          org.org_id !== 72 &&
                          org.org_id !== 103 &&
                          org.org_id !== 117 &&
                          org.org_id !== 120 &&
                          org.org_id !== 173 &&
                          org.org_id !== 194 ? (
                          <Fragment>
                            <ListGroupItem
                              className="py-0"
                              action
                              active={org.org_id === activeItem}
                            >
                              <Row className="py-2">
                                <Col xs={1} lg={1}>
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      transition: "background-color 0.3s",
                                    }}
                                    className="text-end ps-3"
                                    onClick={() => {
                                      toggleCollapseNested(org.org_id);
                                      setButton(org.org_id);
                                      setButtonIcons(prevState => ({
                                        ...prevState,
                                        [org.org_id]:
                                          prevState[org.org_id] ===
                                            "fa-solid fa-minus"
                                            ? "fa-solid fa-plus"
                                            : "fa-solid fa-minus",
                                      }));
                                    }}
                                  >
                                    {buttonIcons[org.org_id] ? (
                                      <i
                                        className={buttonIcons[org.org_id]}
                                      ></i>
                                    ) : (
                                      <i className="fa-solid fa-plus "></i>
                                    )}
                                  </span>
                                </Col>
                                <Col xs={6} lg={11}>
                                  <div
                                    className="ms-3"
                                    key={org.org_id}
                                    readOnly
                                    defaultValue={org.org_name}
                                    onClick={() =>
                                      handleListItemClick(
                                        org.org_id,
                                        org.org_name
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      transition: "background-color 0.3s",
                                    }}
                                  >
                                    {org.org_name}
                                  </div>
                                </Col>
                              </Row>
                            </ListGroupItem>
                            <Collapse isOpen={isOpenCollapseNested[org.org_id]}>
                              {org.child.sort((a, b) => {
                                  const nameA = a.org_name.toLowerCase();
                                  const nameB = b.org_name.toLowerCase();
                                  if (nameA < nameB) return -1;
                                  if (nameA > nameB) return 1;
                                  return 0;
                                }).map(i =>
                                i.active !== 0 &&

                                 i.active !== undefined ? (
                                  <ListGroupItem
                                    className="py-0"
                                    action
                                    active={i.org_id === activeItem}
                                  >
                                    <div
                                      key={i.org_id}
                                      className="py-2"
                                      onClick={() =>
                                        handleListItemClick(
                                          i.org_id,
                                          i.org_name
                                        )
                                      }
                                      style={{
                                        cursor: "pointer",
                                        transition: "background-color 0.3s",
                                        marginLeft: "4rem",
                                      }}
                                    >
                                      {i.org_name}
                                    </div>
                                  </ListGroupItem>
                                ) : (
                                  ""
                                )
                              )}
                            </Collapse>
                          </Fragment>
                        ) : org.child.length !== 0 && org.active !== undefined && org.active !== 0 && taskFilter === "NEED_ADMINISTER" ?
                          <Fragment>
                            <ListGroupItem
                              className="py-0"
                              action
                              active={org.org_id === activeItem}
                            >
                              <Row className="py-2">
                                <Col xs={1} lg={1}>
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      transition: "background-color 0.3s",
                                    }}
                                    className="text-end ps-3"
                                    onClick={() => {
                                      toggleCollapseNested(org.org_id);
                                      setButton(org.org_id);
                                      setButtonIcons(prevState => ({
                                        ...prevState,
                                        [org.org_id]:
                                          prevState[org.org_id] ===
                                            "fa-solid fa-minus"
                                            ? "fa-solid fa-plus"
                                            : "fa-solid fa-minus",
                                      }));
                                    }}
                                  >
                                    {buttonIcons[org.org_id] ? (
                                      <i
                                        className={buttonIcons[org.org_id]}
                                      ></i>
                                    ) : (
                                      <i className="fa-solid fa-plus "></i>
                                    )}
                                  </span>
                                </Col>
                                <Col xs={6} lg={11}>
                                  <div
                                    className="ms-3"
                                    key={org.org_id}
                                    readOnly
                                    defaultValue={org.org_name}
                                    onClick={() =>
                                      handleListItemClick(
                                        org.org_id,
                                        org.org_name
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      transition: "background-color 0.3s",
                                    }}
                                  >
                                    {org.org_name}
                                  </div>
                                </Col>
                              </Row>
                            </ListGroupItem>
                            <Collapse isOpen={isOpenCollapseNested[org.org_id]}>
                              {org.child.sort((a, b) => {
                                  const nameA = a.org_name.toLowerCase();
                                  const nameB = b.org_name.toLowerCase();
                                  if (nameA < nameB) return -1;
                                  if (nameA > nameB) return 1;
                                  return 0;
                                }).map(i =>
                                i.active !== 0 &&

                                i.active !== undefined ? (
                                  <ListGroupItem
                                    className="py-0"
                                    action
                                    active={i.org_id === activeItem}
                                  >
                                    <div
                                      key={i.org_id}
                                      className="py-2"
                                      onClick={() =>
                                        handleListItemClick(
                                          i.org_id,
                                          i.org_name
                                        )
                                      }
                                      style={{
                                        cursor: "pointer",
                                        transition: "background-color 0.3s",
                                        marginLeft: "4rem",
                                      }}
                                    >
                                      {i.org_name}
                                    </div>
                                  </ListGroupItem>
                                ) : (
                                  ""
                                )
                              )}
                            </Collapse>
                          </Fragment> : ""
                      )}
                    </Collapse>
                    
                  </Fragment>
                </ListGroup>
              ) : valueSearch.length !== 0 ? (
                valueSearch.map(([org_name, org_id, active], index) =>
                  active !== 0 &&
                  active !== undefined &&
                  org_id !== 57 &&
                  org_id !== 58 &&
                  org_id !== 72 &&
                  org_id !== 103 &&
                  org_id !== 117 &&
                  org_id !== 120 &&
                  org_id !== 173 &&
                  org_id !== 194 ? (
                    <Fragment key={index}>
                      <ListGroup>
                        <ListGroupItem
                          action
                          active={org_id === activeItem}
                          className="py-0"
                          key={org_id}
                        >
                          <div
                            className="my-2"
                            onClick={() =>
                              handleListItemClick(org_id, org_name)
                            }
                            style={{
                              cursor: "pointer",
                              transition: "background-color 0.3s",
                            }}
                          >
                            {org_name}
                          </div>
                        </ListGroupItem>
                      </ListGroup>
                    </Fragment>
                  ) :  active !== undefined && active !== 0 && taskFilter === "NEED_ADMINISTER" ?
                      <Fragment key={index}>
                        <ListGroup>
                          <ListGroupItem
                            action
                            active={org_id === activeItem}
                            className="py-0"
                            key={org_id}
                          >
                            <div
                              className="my-2"
                              onClick={() =>
                                handleListItemClick(org_id, org_name)
                              }
                              style={{
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                              }}
                            >
                              {org_name}
                            </div>
                          </ListGroupItem>
                        </ListGroup>
                      </Fragment>
                  : valueSearch.length === 1 ? (
                    <div className="text-center">ไม่พบข้อมูล</div>
                  ) : (
                    ""
                  )
                )
              ) : (
                <div className="text-center">ไม่พบข้อมูล</div>
              )}
            </FadeIn>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              toggle();
              handleFinalClick();
            }}
          >
            เลือก
          </Button>
          <Button
            color="danger"
            onClick={() => {
              toggle();
              handleClearClick();
            }}
          >
            ยกเลิก
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

export default ModalConID;
